export default __webpack_public_path__ + "static/media/Banner_NVI.bfc97571.png";